import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
/**
 * This higher order function can be used for the home or story page preview. It takes a component, and a function to map the story into props suitable for the component
 * 
 * Preview in the Quintype CMS works by sending a postMessage to an iframe every time the story changes. This file abstracts this for you, and will just render the given component
 *
 * Example
 * ```javascript
 * import { WithPreview, replaceAllStoriesInCollection } from '@quintype/components';
 * import { StoryPage } from '../pages/story';
 * import { HomePage } from '../pages/home';
 *
 * function storyPageData(data, story) {
 *   return {...data, story, relatedStories: Array(5).fill(story)};
 * }
 *
 * // Remember to update load-data.js for the initial data
 * function homePageData(data, story) {
 *   return {...data, collection: replaceAllStoriesInCollection(data.collection, story)};
 * }
 *
 * export const StoryPreview = WithPreview(StoryPage, storyPageData);
 * export const HomePreview = WithPreview(HomePage, homePageData)
 * ```
 * @param {Component} klazz
 * @param {function} updateData
 * @category Other
 * @returns {Component} Component which can be used for preview
 */

export function WithPreview(klazz, updateData) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(WithPreviewWrapper, _React$Component);

    var _super = _createSuper(WithPreviewWrapper);

    function WithPreviewWrapper(props) {
      var _this;

      _classCallCheck(this, WithPreviewWrapper);

      _this = _super.call(this, props);
      _this.state = {
        story: null
      };
      return _this;
    }

    _createClass(WithPreviewWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        global.addEventListener("message", function (event) {
          if (event.data && event.data.action == 'reloadStory' && event.data.story) {
            _this2.setState({
              story: event.data.story
            });
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        if (!this.state.story) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              minHeight: 200
            }
          });
        }

        return /*#__PURE__*/React.createElement(klazz, Object.assign({}, this.props, {
          data: updateData(this.props.data, this.state.story)
        }));
      }
    }]);

    return WithPreviewWrapper;
  }(React.Component);
}